module.exports = __webpack_public_path__ + "media/images/icons/twotone/container-d9dd120dbebb22fe35648f0ee26782ea.svg";